/**
 * @generated SignedSource<<c51bad039561d1800548ac9d0ba49f8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateGithubVerificationKeyInput = {
  currentUrl?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createGithubVerificationKeyMutation$variables = {
  input: CreateGithubVerificationKeyInput;
};
export type createGithubVerificationKeyMutation$data = {
  readonly createGithubVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createGithubVerificationKeyMutation = {
  variables: createGithubVerificationKeyMutation$variables;
  response: createGithubVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGithubVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createGithubVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createGithubVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createGithubVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8199e9fbe5e0625c834cea1c7e6f0b1f",
    "id": null,
    "metadata": {},
    "name": "createGithubVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createGithubVerificationKeyMutation(\n  $input: CreateGithubVerificationKeyInput!\n) {\n  createGithubVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4f34a5ba08be8064e613c34a01d4c09";

export default node;
